import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAi';
/** Renders an SVG icon. */
const SvgAi = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M13 9a1 1 0 0 0-.906.577l-2.25 4.819a3 3 0 0 1-1.448 1.449l-4.819 2.249a1 1 0 0 0 0 1.812l4.819 2.25a3 3 0 0 1 1.449 1.449l2.249 4.818a1 1 0 0 0 1.812 0l2.25-4.818a3 3 0 0 1 1.449-1.45l4.818-2.249a1 1 0 0 0 0-1.812l-4.818-2.25a3 3 0 0 1-1.45-1.448l-2.249-4.819A1 1 0 0 0 13 9m1.343 6.241a5 5 0 0 0 2.416 2.416L19.636 19l-2.877 1.343a5 5 0 0 0-2.416 2.416L13 25.635l-1.343-2.876a5 5 0 0 0-2.416-2.416L6.365 19l2.876-1.343a5 5 0 0 0 2.416-2.416L13 12.364zM23 3a1 1 0 0 0-.906.577l-.976 2.091a3 3 0 0 1-1.45 1.45l-2.09.976a1 1 0 0 0 0 1.812l2.09.976a3 3 0 0 1 1.45 1.45l.976 2.09a1 1 0 0 0 1.812 0l.976-2.09a3 3 0 0 1 1.45-1.45l2.09-.976a1 1 0 0 0 0-1.812l-2.09-.976a3 3 0 0 1-1.45-1.45l-.976-2.09A1 1 0 0 0 23 3m.07 3.514a5 5 0 0 0 2.416 2.417l.15.069-.15.07a5 5 0 0 0-2.417 2.416l-.069.149-.07-.149a5 5 0 0 0-2.416-2.417L20.365 9l.149-.07a5 5 0 0 0 2.417-2.416l.069-.15zm4.657 7.971a.25.25 0 0 0-.454 0l-.53 1.137a.25.25 0 0 1-.12.12l-1.138.531a.25.25 0 0 0 0 .454l1.137.53a.25.25 0 0 1 .12.12l.531 1.138a.25.25 0 0 0 .454 0l.53-1.137a.25.25 0 0 1 .12-.12l1.138-.531a.25.25 0 0 0 0-.454l-1.137-.53a.25.25 0 0 1-.12-.12z"
      />
    </svg>
  );
};
SvgAi.displayName = displayName;
export default SvgAi;
